import React from "react";
import styled, {css} from 'styled-components';
import translate from "../../../providers/i18n/translate";

const Root = styled.th`
    width: auto;
    display: ${(props) => props.hidden ? "none" : props.hiddenMobile ? "none" : "table-cell"};
    text-align: ${(props) => props.align ? props.align : "left"};
    border-bottom: 2px solid #C6C6C6;
    line-height: 2rem;
    color: ${(props) => props.color ? props.color : "#000"};
    vertical-align: middle;
    text-transform: uppercase;
    font-size: 0.875rem;
    position: sticky;
    top: 0;
    background-color: ${(props) => props.backgroundColor ? props.backgroundColor : "#FFF"};
    padding: 8px 10px;
    @media (min-width: 400px) {
        display: ${(props) => props.hidden ? "none" : "table-cell"};
        width: ${(props) => props.width ? props.width : "auto"};
        ${props => props.fixedWidth ? css`width: ${props.fixedWidth}; min-width: ${props.fixedWidth}; max-width: ${props.fixedWidth}};` : ''}
        line-height: 1.5rem;
    }
`

const HeaderCell = ({children, width, fixedWidth, hidden, hiddenMobile, align, color, backgroundColor}) => {
    return (
        <Root width={width} fixedWidth={fixedWidth} hidden={hidden} hiddenMobile={hiddenMobile} align={align} color={color} backgroundColor={backgroundColor}>
            {children}
        </Root>   
    );
}

export default HeaderCell;